import { Flex, Pane, Content } from '@leverege/ui-elements'
import React from 'react'
import Tables from './components/Tables'

function HeadCount( props ) {

  return (
    <Content>
      <Content.Area>
        <Pane
          id="main_pane"
          style={{
            justifyContent : 'center',
            alignItems : 'center',
            height : '100%',
            flexWrap : 'wrap'
          }}>
          <Flex gap={14} wrap="wrap">
            <Tables {...props}/>
          </Flex>
        </Pane>
      </Content.Area>
    </Content>
  )
}

export default HeadCount
